export default __webpack_public_path__ + "static/media/roboposition2.7200d58d.svg";